import { useIntl } from 'react-intl'

import Typography from '../../../../../../../../../../components/Typography/Typography'
import { formatDate } from '../../../../../../../../../../global/helpers'

import './OverviewTable.scss'

const OverviewTable = ({ data }) => {
    const intl = useIntl()

    return (
        <table className="overview-table">
            <tbody>
                <tr className="overview-table--header">
                    <th>
                        <Typography variant={'tableLabel'}>
                            {intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.date' })}
                        </Typography>
                    </th>
                    <th className="w-100 purchase">
                        <Typography variant={'tableLabel'}>
                            {intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.purchase' })}
                        </Typography>
                    </th>
                    <th>
                        <Typography variant={'tableLabel'}>
                            {intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.points' })}
                        </Typography>
                    </th>
                </tr>
                {data?.map(({ date, text, points, operation }, i) => (
                    <tr className="overview-table--summary" key={i}>
                        <td className="text-nowrap">
                            <Typography variant={'tableText'}>{formatDate(date)}</Typography>
                        </td>
                        <td className="purchase">
                            <Typography variant={'tableText'}>{text ?? operation}</Typography>
                        </td>
                        <td>
                            <Typography variant={'tableText'} className="d-flex text-nowrap">
                                {points}&nbsp;
                                <span className="summary-points">
                                    {intl.formatMessage({ id: 'global.currency.points' }, { points: '' })}
                                </span>
                            </Typography>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default OverviewTable
